export default __webpack_public_path__ + "static/image3-f143b3ae0d1b45978ad03ccbdcee8364.jpeg";